import React, { useRef, useState } from "react";

import { Form, Formik } from "formik";
import Swal from "sweetalert2";

import {
  Flex,
  Grid,
  GridItem,
  SimpleGrid,
  useDisclosure,
} from "@chakra-ui/react";

import { CustomInputWField } from "../CustomInputWField";
import { CustomButton } from "../CustomButton";
import { FiliacaoCadastrar } from "../../pages/Criancas/Filiacao/Cadastrar";
import { cpf, forNames } from "../../utils/masks";

import FiliacoesService from "../../../main/services/FiliacoesService";
import { Permission, criancaFunc } from "../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../Context/AuthProvider";

export const FiltersFiliacao = ({
  filiacoes,
  form,
  data,
  setData,
  setFiliacoes,
  initialFiliacao,
  onCloseFiliacoes,
  setLoading,
  onOpenEditar,
  setSelected,
  tempSelected,
  idPJ,
}) => {
  const formRef = useRef(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedCadastrar, setSelectedCadastrar] = useState(false);
  const [showCadastrar, setShowCadastrar] = useState(false);
  const [newData, setNewData] = useState();
  const [CPFSearch, setCPFSearch] = useState("");
  const [validCPF, setValidCPF] = useState(false);
  //const [opcoesFiliacao, setOpcoesFiliacao] = useState([]);
  const [name, setName] = useState("");
  const [cpfCadastro, setcpfCadastro] = useState("");
  //const [cpfChange, setCPFChange] = useState("");
  const { roleKeycloack, user } = useAuthProvider();
  const [initialValues] = useState({
    tipo: initialFiliacao
      ? initialFiliacao === "Mãe*"
        ? { label: "Mãe", value: "Mãe" }
        : { label: "Pai", value: "Pai" }
      : "",
    nome: "",
    cpf: "",
  });

  const url = window.location.href;

  const cadastrarAlert = (cpf, newData, filiacao) => {
    const dentroFicha = filiacoes.filter(
      (filiacao) =>
        filiacao?.cpf?.replace(/[.-]|[.-](?=.)/g, "").trim() ===
        CPFSearch?.replace(/[.-]|[.-](?=.)/g, "").trim()
    );
    if ((!cpf && !validCPF) || dentroFicha.length > 0) {
      Swal.fire({
        title: (cpf && validCPF) || dentroFicha.length > 0 ? "Atenção!" : ``,
        text:
          dentroFicha.length > 0
            ? "Filiação já cadastrada na ficha."
            : cpf && validCPF && newData.totalElements === 0
            ? `Já existe uma filiação com o CPF ${cpf}.`
            : "",
        icon: "warning",
        showCancelButton:
          (cpf && validCPF) || dentroFicha.length > 0 ? false : true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          if (!cpf) {
            onOpenEditar();
          }
        }
      });
    } else {
      onOpen();
    }
  };

  const cadastrarAlertName = (newData, props) => {
    // const setarNome = newData?.content
    //   .map((item) => item.nome)
    //   .filter(
    //     (item) =>
    //       normalizeString(item.trim()) ===
    //       normalizeString(props.values.nome.trim())
    //   );

    // const diferentName = filiacoes
    //   .map((item) => item.nome)
    //   .filter(
    //     (item) =>
    //       normalizeString(item.trim()) ===
    //       normalizeString(props.values.nome.trim())
    //   );

    if (props.values.nome && newData?.totalElements > 0) {
      Swal.fire({
        title: `Sua consulta encontrou ${
          newData ? newData.totalElements : ""
        } registros`,
        text: "Tem certeza que deseja cadastrar um novo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          setName(props.values.nome);
          setcpfCadastro(props.values.cpf);
          onOpen();
        }
      });
    } else {
      setName(props.values.nome);
      setcpfCadastro(props.values.cpf);
      onOpen();
    }
  };

  const handleSubmit = (values, actions) => {
    setTimeout(async () => {
      const { tipo, cpf, nome, ...resto } = values;

      const valuesToSend = {
        tipo: tipo ? tipo.value : "",
        cpf: cpf ? cpf : "",
        nome: nome ? nome.trim() : "",
        ...resto,
      };

      setShowCadastrar(true);
      setLoading(true);
      const res = await FiliacoesService.pesquisarFiliacoes(valuesToSend);

      setData(res?.data?.content);
      setNewData(res?.data);
      //const nomeCPF = res?.data?.content?.map((item) => item?.nome);

      const resValid = await FiliacoesService.validarFiliacoesCPF(cpf);

      setValidCPF(resValid?.data?.filiacao);

      // const dentroFicha = filiacoes.filter(
      //   (filiacao) =>
      //     filiacao?.cpf?.replace(/[.-]|[.-](?=.)/g, "").trim() ===
      //       cpf?.replace(/[.-]|[.-](?=.)/g, "").trim() && cpf
      // );

      // if (
      //   (nome &&
      //     !cpf &&
      //     dentroFicha &&
      //     dentroFicha.length > 0 &&
      //     res?.data.totalElements > 0) ||
      //   (cpf && resValid.data.filiacao && res?.data.totalElements > 0)
      // ) {
      //   Swal.fire({
      //     title: "Atenção!",
      //     text:
      //       dentroFicha && dentroFicha.length > 0
      //         ? `Filiação já cadastrada na ficha.`
      //         : `O CPF ${cpf} pertence a ${nomeCPF}. Deseja utilizar os mesmos dados?`,
      //     icon: "warning",
      //     showCancelButton:
      //       dentroFicha && dentroFicha.length > 0 ? false : true,
      //     confirmButtonColor: "#169499",
      //     cancelButtonColor: "#169499",
      //     confirmButtonText:
      //       dentroFicha && dentroFicha.length > 0 ? "Ok" : "Sim",
      //     cancelButtonText: "Não",
      //   }).then((result) => {
      //     if (result.isConfirmed && dentroFicha && dentroFicha.length <= 0) {
      //       setSelectedCadastrar(true);
      //       setSelected(resValid.data.filiacao);
      //       onOpen();
      //     }
      //   });
      // }

      setCPFSearch(cpf ? cpf : "");
      setLoading(false);
      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <Flex flexDir="column" alignItems="center" w="100%">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(props) => (
          <Form
            ref={formRef}
            style={{ width: "100%" }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                props.handleSubmit();
              }
            }}
          >
            <Flex flexDirection="column" alignItems="center">
              <Grid templateColumns="repeat(8, 1fr)" gap="25px" w="100%">
                <GridItem colSpan={{ base: 3, lg: 1 }}>
                  {/* <CustomSelectWField
                    fieldName="tipo"
                    label="Vínculo"
                    placeholder="Selecione o Vínculo"
                    options={opcoesFiliacao}
                    onChange={(value) => {
                      props.setFieldValue("tipo", value);
                    }}
                    isDisabled={
                      !!initialFiliacao || opcoesFiliacao.length === 1
                    }
                  /> */}
                </GridItem>
                <GridItem colSpan={{ base: 3, lg: 3 }}>
                  <CustomInputWField
                    fieldName="cpf"
                    label="CPF"
                    placeholder="000.000.000-00"
                    maxLength={14}
                    onChange={(e) =>
                      props.setFieldValue("cpf", cpf(e.target.value))
                    }
                  />
                </GridItem>
                <GridItem colSpan={{ base: 3, lg: 3 }}>
                  <CustomInputWField
                    fieldName="nome"
                    label="Nome"
                    placeholder="Pesquise pelo Nome"
                    onChange={(e) =>
                      props.setFieldValue("nome", forNames(e.target.value))
                    }
                  />
                </GridItem>
              </Grid>

              <SimpleGrid
                mt="20px"
                columns={3}
                spacing="15px"
                w={{ base: "100%", lg: "60%" }}
              >
                {!url.includes("/cadastrar") ? (
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={criancaFunc.buscarFiliacao}
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    <CustomButton
                      type="submit"
                      translate="no"
                      onClick={props.handleSubmit}
                      label="Pesquisar"
                    />
                  </Permission>
                ) : (
                  <CustomButton
                    type="submit"
                    translate="no"
                    onClick={props.handleSubmit}
                    label="Pesquisar"
                  />
                )}
                <CustomButton type="reset" label="Limpar" />
                {showCadastrar && (
                  <CustomButton
                    label="Cadastrar"
                    isDisabled={props.isSubmitting}
                    onClick={
                      validCPF ||
                      (
                        CPFSearch &&
                        filiacoes.filter(
                          (filiacao) => filiacao.cpf === CPFSearch
                        )
                      ).length > 0
                        ? () => cadastrarAlert(CPFSearch, newData, props)
                        : () => cadastrarAlertName(newData, props)
                    }
                  />
                )}

                <FiliacaoCadastrar
                  isOpen={isOpen}
                  onOpen={onOpen}
                  onClose={onClose}
                  name={name}
                  cpfCadastro={cpfCadastro}
                  onCloseFiliacoes={() => {
                    setData(null);
                    onCloseFiliacoes();
                  }}
                  form={form}
                  filiacoes={filiacoes}
                  selectedFiliacao={tempSelected}
                  setSelected={setSelected}
                  setNovaFiliacao={setFiliacoes}
                  initialFiliacao={initialFiliacao}
                  selectedCadastrar={selectedCadastrar}
                  setSelectedCadastrar={setSelectedCadastrar}
                />
              </SimpleGrid>
            </Flex>
          </Form>
        )}
      </Formik>
    </Flex>
  );
};
